import { Component, OnInit, Input } from '@angular/core';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { Router } from '@angular/router';
import { ViewDetailsModal } from 'src/modules/features/contractor/modals';
import { ViewDepositSlipModal } from 'src/modules/features/contractor/modals/view-deposit-slip-modal/view-deposit-slip-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-transactions-row',
  templateUrl: './transactions-row.component.html',
  styleUrls: ['./transactions-row.component.scss'],
})
export class TransactionsRowComponent implements OnInit {

  @Input() account: any;
  @Input() currencyCode: string;

  sanitizedUrl;
  baseUrl = environment.API_SERVER;

  constructor(private modalService: SuiModalService, private router: Router, private sanitizer: DomSanitizer) {}

  viewDetails () {
    this.modalService.open(
      new ViewDetailsModal("Transaction Details", this.account)
    )
  }

  viewDepositSlip () {
    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustUrl(`${this.baseUrl}/finance/public/media/?media=${this.account.transactionDocumentPath}`);
    // this.modalService.open(
    //   new ViewDepositSlipModal(this.account.transactionDocumentPath)
    // )
  }

  ngOnInit(): void {}
}
